var TATheme = (function($) {

    "use strict";

    var onceInstantiatedModules;
    var $measureLi;
    var $getWidth;
    var $header = $('#main-header');
    var $clientHeight = $('#main-content-area section').first();
    var $getWidth;
    var smoother;
    
    function wrapRateDecimals() {
        var $rates = $('.rate__pct');
        
        $rates.each(function() {
            var $this = $(this);
            var originalText = $this.text();
            var rateText = originalText.replace(/\s+/g, '').trim();
            
            if (!rateText) return;

            try {
                var matches = rateText.match(/(\d+)\.(\d+)%/);
                
                if (matches && matches.length === 3) {
                    var beforeDecimal = matches[1];
                    var decimalPart = matches[2];
                    $this.html(beforeDecimal + '.<span class="decimal">' + decimalPart + '</span>%');
                } else {
                    var parts = rateText.split('.');
                    if (parts.length === 2) {
                        var percentParts = parts[1].split('%');
                        if (percentParts.length === 2 && /^\d+$/.test(parts[0]) && /^\d+$/.test(percentParts[0])) {
                            $this.html(parts[0] + '.<span class="decimal">' + percentParts[0] + '</span>%');
                        }
                    }
                }
            } catch (e) {
                console.warn('Error processing rate text:', e);
            }
        });
    }
  
    function init($) {
    
      onceInstantiatedModules = ["TATheme", "TAHeader"];
      TAHeader.init();
      init_modules();
    }

    function collapseHeader(elm) {

            //
            // Watch for scroll past the tracker and apply class to header...
            //
            const observer = new IntersectionObserver( entries => {

              if ( entries[0].boundingClientRect.y < 0 ) {

                if( !($header.hasClass('scrolled')) ) {
                  $header.addClass('scrolled');
                }
              } else {
                if( ($header.hasClass('scrolled')) ) {
                  $header.removeClass('scrolled');
                }
              }

            });

            observer.observe( document.querySelector('.header-tracker') );

    }

    //
    // Await an element's existence..
    //
    function waitForElm(selector) {

        return new Promise(resolve => {

            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }

        });

    }
  
    function init_modules() {
  
      $("body").addClass("ready");

      // Set up the site for smooth scrolling via GSAP
      //
      gsap.registerPlugin(ScrollTrigger,ScrollSmoother,ScrollToPlugin);

      if ( ScrollTrigger.isTouch != 1 ) {

        smoother = ScrollSmoother.create({
          wrapper: '#main-content-area',
          content: '#smooth-content',
          smooth: 2.4,
          normalizeScroll: true,
          effects: true
        });

        // Prevent default hash behavior
        history.scrollRestoration = 'manual';
        
        // Handle initial deep linking
        let urlHash = window.location.href.split("#")[1];
        if (urlHash) {
          let scrollElem = document.querySelector("#" + urlHash);
          if (scrollElem) {
            // Prevent default jump and smoothly scroll
            window.scrollTo(0, 0);
            setTimeout(() => {
              smoother.scrollTo(scrollElem, {duration: 2});
            }, 100);
          }
        }

        // Handle dynamic hash changes and anchor clicks
        window.addEventListener('hashchange', function(e) {
          e.preventDefault();
          let newHash = window.location.hash;
          if (newHash) {
            let targetElem = document.querySelector(newHash);
            if (targetElem) {
              smoother.scrollTo(targetElem, {duration: 2});
            }
          }
        });

        // Prevent default anchor behavior and use smooth scroll
        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
          anchor.addEventListener('click', function(e) {
            e.preventDefault();
            const targetId = this.getAttribute('href');
            if (targetId !== '#') {
              const targetElem = document.querySelector(targetId);
              if (targetElem) {
                // Update URL with hash for browser history
                if (history.pushState) {
                  history.pushState(null, null, targetId);
                } else {
                  location.hash = targetId;
                }
                smoother.scrollTo(targetElem, {duration: 2});
              }
            }
          });
        });
      } else {
        // Handle hash-based links for mobile devices (when ScrollTrigger.isTouch == 1)
        // or when window width is 1080px or less
        
        // Handle initial deep linking on mobile
        let urlHash = window.location.href.split("#")[1];
        if (urlHash) {
          let scrollElem = document.querySelector("#" + urlHash);
          if (scrollElem) {
            // Scroll to element with a slight delay to ensure DOM is ready
            setTimeout(() => {
              scrollElem.scrollIntoView({ behavior: 'smooth' });
            }, 100);
          }
        }
        
        // Handle hash changes on mobile
        window.addEventListener('hashchange', function(e) {
          let newHash = window.location.hash;
          if (newHash) {
            let targetElem = document.querySelector(newHash);
            if (targetElem) {
              // Prevent the default jump
              e.preventDefault();
              // Smooth scroll to the element
              targetElem.scrollIntoView({ behavior: 'smooth' });
            }
          }
        });
        
        // Handle anchor clicks on mobile
        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
          anchor.addEventListener('click', function(e) {
            const targetId = this.getAttribute('href');
            if (targetId !== '#') {
              const targetElem = document.querySelector(targetId);
              if (targetElem) {
                // Prevent the default jump
                e.preventDefault();
                // Update URL with hash for browser history
                if (history.pushState) {
                  history.pushState(null, null, targetId);
                } else {
                  location.hash = targetId;
                }
                // Smooth scroll to the element
                targetElem.scrollIntoView({ behavior: 'smooth' });
              }
            }
          });
        });
        
        // Add a specific handler for window resize to handle responsive behavior
        window.addEventListener('resize', function() {
          if (window.innerWidth <= 1080) {
            // Ensure mobile scrolling behavior is applied
            document.querySelectorAll('a[href^="#"]').forEach(anchor => {
              // Remove any existing event listeners (to avoid duplicates)
              const oldAnchor = anchor.cloneNode(true);
              anchor.parentNode.replaceChild(oldAnchor, anchor);
              
              // Add the mobile-specific event listener
              oldAnchor.addEventListener('click', function(e) {
                const targetId = this.getAttribute('href');
                if (targetId !== '#') {
                  const targetElem = document.querySelector(targetId);
                  if (targetElem) {
                    e.preventDefault();
                    if (history.pushState) {
                      history.pushState(null, null, targetId);
                    } else {
                      location.hash = targetId;
                    }
                    targetElem.scrollIntoView({ behavior: 'smooth' });
                  }
                }
              });
            });
          }
        });
        
        // Trigger the resize handler once on load to apply correct behavior based on initial screen size
        if (window.innerWidth <= 1080) {
          window.dispatchEvent(new Event('resize'));
        }
      }

      Object.getOwnPropertyNames(window).forEach( function(name) {

        if (
          name.indexOf("TA") < 0 ||
          onceInstantiatedModules.indexOf(name) > -1 ||
          !window[name].hasOwnProperty("init")
        ) {
          return;
        }
        var _instance = window[name];
  
        _instance.init();

      });
  
      MicroModal.init({
        disableScroll: true,
        awaitCloseAnimation: true
      });


      const main = document.querySelector("#main");
      const foot = document.querySelector("#footer");



		//
		// Animation Observer/Handler
		const config = {
			root: null,
			rootMargin: '150px',
			threshold: [.75]
		};
		  
		let previousY = 0;
		let previousRatio = 0;
		  
		  
		let observer = new IntersectionObserver( function(entries) {
			entries.forEach( entry => {

				const currentY = entry.boundingClientRect.y;
				const currentRatio = entry.intersectionRatio;
				const isIntersecting = entry.isIntersecting;
				const element = entry.target;
				
				// use this if direction is both ways
				// element.classList.remove('animated');

				// Scrolling up
				if ( currentY < previousY || currentRatio >= config.threshold ) {
					const className = (currentRatio >= previousRatio) ? "animated" : "outview-top";
					element.classList.add(className);
				} 
				// use this if direction is both ways
				// 	// Scrolling down
				//   } else if (currentY > previousY) {
				// 	const className = (currentRatio <= previousRatio) ? "outview-bottom" : "animated";
				// 	element.classList.add(className);
				//   }
			
				previousY = currentY;
				previousRatio = currentRatio;
			  
			})
		  }, config);

		  const animates = document.querySelectorAll('.animate');
		  animates.forEach( animate => {
			  observer.observe(animate);
		  });      

  
      wrapRateDecimals();

    } // end init_modules
  
    return {
      init: init,
      init_modules: init_modules
    };
  })(jQuery);

// (function($){
  
  jQuery(document).ready( function() {
    TATheme.init();
  });

// });
  